import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './components/about/about.component';
import { LoginClaveGuard, LoginGuard } from './components/core/_infrastructure/classes/guards/main.guard';
import { UserPlaygroundAuthGuard } from './components/core/_infrastructure/classes/guards/user-playground-auth.guard';
import { HomeComponent } from './components/home/home.component';
import { InstruccionesComponent } from './components/instrucciones/instrucciones.component';
import { PageNotFoundComponent } from './components/pagenotfound/pagenotfound.component';
import { ProteccionDatosComponent } from './components/protecciondatos/protecciondatos.component';
import { SoporteComponent } from './components/soporte/soporte.component';
import { ErrorComponent } from './components/error/error.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { LogoutComponent } from './components/core/components/logout/logout.component';
//import { UsuariosExModule } from './components/_sede/asistentes/altausuariosexternos/altausuariosexternos.module';

const appSharedRoutes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'home',
        component: HomeComponent,
    },
    {
        path: 'playground',
        loadChildren: () => import('./components/playground/playground.module').then(mod => mod.PlaygroundModule),
        //loadChildren: () => PlaygroundModule,
        canActivate: [LoginGuard(), UserPlaygroundAuthGuard()],
        data: {
            breadcrumb: 'Playground',
        },
    },
    { path: 'instrucciones', component: InstruccionesComponent },
    { path: 'protecciondatos', component: ProteccionDatosComponent },
    { path: 'about', component: AboutComponent },
    { path: 'soporte', component: SoporteComponent },
    {
        path: 'gestorcontenidos',
        // loadChildren: () => GestorContenidosModule,
        loadChildren: () => import('./components/_gestor/gestorcontenidos.module').then(mod => mod.GestorContenidosModule),
        data: {
            breadcrumb: 'Noticias y Avisos',
        },
    },
    {
        path: 'login',
        canActivate: [LoginClaveGuard()],
        component: HomeComponent,
    },
    {
        path: 'logout',
        // canActivate: [LoginClaveGuard()],
        component: LogoutComponent,
    },
    { path: 'error/:errorId', component: ErrorComponent },
    //{
    //    path: 'sede',
    //    loadChildren: () => UsuariosExModule,
    //    data: {
    //        breadcrumb: 'Asistente',
    //    },
    //},
    { path: 'notaccesible', component: NotAuthorizedComponent },
    { path: '**', component: PageNotFoundComponent },
];
@NgModule({
    imports: [RouterModule.forChild(appSharedRoutes)],
    exports: [RouterModule],
})
export class AppSharedRoutingModule {}
